import { FileInput, FileInputProps } from '@mi-front/ui';
import InfoIcon from '@mui/icons-material/Info';
import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';

export function NoFilesSelected(p: { onChange: FileInputProps['onChange'] }) {
  return (
    <Box className="text-muted">
      <div>
        <FileInput
          name="files"
          className="mr-2"
          onChange={p.onChange}
          accept="audio/*,video/mp4,video/x-m4v,video/*"
        />
      </div>

      <div className="bg-gray-100 d-inline-block p-4 mt-4 rounded">
        <div className="d-flex align-items-center">
          <InfoIcon sx={{ fontSize: 40 }} />
          <div className="ml-3 text-left">
            <FormattedMessage
              id="audit.uploadScreen.apiHint"
              defaultMessage={`
        También puedes cargar archivos utilizando nuestra API. {br}
        Visita la {docLink} para más instrucciones.
      `}
              values={{
                docLink: (
                  <a
                    href={'https://logger-api.mediainbox.io/docs/#api-Audit-AuditAudioUpload'}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FormattedMessage
                      id="audit.uploadScreen.documentation"
                      defaultMessage="documentación"
                    />
                  </a>
                ),
                br: <br />,
              }}
            />
          </div>
        </div>
      </div>
    </Box>
  );
}
